import React from "react";
import { DocAttachButton } from "./DocAttachButton";

export const ActionButtons = ({ s3Key, s3Bucket }) => {
  return <DocAttachButton s3Key={s3Key} s3Bucket={s3Bucket}></DocAttachButton>;
};
